module.exports = __webpack_public_path__ + "static/img/logo.985047b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/common/logo.png
// module id = 1X89
// module chunks = 11